import React from "react";
import { ReturnTypesEnum } from "@/interfaces/Return";

interface ReturnTypesProps {
  text?: ReturnTypesEnum;
}

const ReturnTypesTag: React.FC<ReturnTypesProps> = ({ text }) => {
  if (!text) return null;

  const backgroundColor: Record<ReturnTypesEnum, string> = {
    [ReturnTypesEnum.RTO_EMM]: "bg-emerald-600",
    [ReturnTypesEnum.RTO_HUB]: "bg-sky-600",
    [ReturnTypesEnum.STANDARD]: "bg-violet-600",
  };

  return (
    <div
      className={`inline-flex items-center rounded-md px-2 py-1 ${backgroundColor[text]}`}
    >
      <p className="text-xs font-medium text-white">{text}</p>
    </div>
  );
};

export default ReturnTypesTag;
